var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "light-blue-board mix-board mt_10" }, [
    _c("div", { staticClass: "mix-title" }, [
      _c("div", { staticClass: "title-name" }, [
        _vm._v("\n      " + _vm._s(_vm.itemData.title || _vm.theme) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "title-value" }, [
      _c("span", [
        _vm._v(
          _vm._s(
            _vm.paddingNum(_vm.itemData.actualCount) == 0
              ? "-"
              : _vm.paddingNum(_vm.itemData.actualCount)
          )
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }